import config from "config";

if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
  if (!document.getElementById("google-analytics")) {
    const gaScript = document.createElement("script");

    gaScript.setAttribute("id", "google-analytics");
    gaScript.setAttribute("async", true);
    gaScript.setAttribute(
      "src",
      `https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GA_MEASUREMENT_ID}`
    );

    document.querySelector("head").append(gaScript);
  }

  window.dataLayer = window.dataLayer || [];
}

function gtag() {
  if (process.env.REACT_APP_GA_ENABLED === "true") {
    window.dataLayer.push(arguments);
  }
}

gtag("js", new Date());
gtag("config", process.env.REACT_APP_GA_MEASUREMENT_ID);

const analytics = {
  sendEvent: (name, params) => {
    if (process.env.NODE_ENV === "development") {
      console.log(`EVENT :: ${name}`, params);
    }

    if (!name) {
      console.error(`sendEvent :: Missing 'name'`);
    } else {
      gtag("event", name, params);
    }
  },
};

export default analytics;

export const omitSensitiveData = (data = {}) =>
  Object.keys(data).reduce(
    (obj, key) => ({
      ...obj,
      [key]:
        typeof data[key] === "object"
          ? omitSensitiveData(data[key])
          : config.sensitiveData.includes(key)
          ? "PRIVATE"
          : data[key],
    }),
    {}
  );
